import dayjs from "dayjs";
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { TitleRegister } from "../../Pets/Pets.styled";
import { Box, IconButton, Typography } from "@mui/material";
import { X } from "@phosphor-icons/react";
import { TextFieldBOValidate } from "../../../TextFieldBO/TextFieldBOValidate";
import { InputCelNumber } from "../../../InputCelNumber";
import { DatePickerCustom } from "../../../DatePickerCustom";
import { FORMAT_DATES } from "../../../../utils/dates";
import { ButtonLoading } from "../../../ButtonLoading";
import { useMutation, useQueryClient } from "react-query";
import { PersonService } from "../../../../services/PersonService";
import { convertToDateARG, getDateToString } from "../../../../utils/functions";
import { useParams } from "react-router-dom";
import CurrentUserContext from "../../../../contexts/CurrentUserContext";
import { namesUseQuery } from "../../../../utils/constants";
import { MedicalData } from "./MedicalData";
import { DataCoberturaMedica } from "./DataCoberturaMedica";
import { AdittionalData } from "./AdittionalData";
import { useSnackBars } from "../../../../contexts/Snackbar/SnackbarContext";

export const FormRegisterPerson = ({ edit = false, data, close }) => {
  const isEditMode = edit && data;
  let { id } = useParams();
  const { userData } = useContext(CurrentUserContext);
  const queryClient = useQueryClient();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackBars();

  const getDefaultValues = () => {
    const birthdate = data?.birthdate ? dayjs(data?.birthdate) : "";
    const lastDateUpdate = convertToDateARG();

    if (isEditMode)
      return {
        ...data,
        birthdate,
        lastDateUpdate,
      };
    return {
      lastDateUpdate,
    };
  };

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
    control,
  } = useForm({
    defaultValues: getDefaultValues(),
    mode: "onChange",
  });

  const { mutate, isLoading } = useMutation(PersonService.setPerson, {
    onSuccess: (res) => {
      showSuccessSnackbar("Persona registrada!");
      edit && close();
      queryClient.invalidateQueries(namesUseQuery?.GET_PERSON_BY_ID);
    },
    onError: (err) => {
      showErrorSnackbar(err?.response?.data?.message);
      console.error(err);
    },
  });

  const onSubmit = async (data, e) => {
    const birthdate = data?.birthdate ? getDateToString(data?.birthdate) : "";
    mutate({
      ...data,
      id,
      uidUser: userData?.uid,
      email: userData?.email,
      birthdate,
      created: true,
    });
  };
  const onError = (errors, e) => console.error(errors);
  const { name } = watch();

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      {!edit ? (
        <TitleRegister>Registrar Persona</TitleRegister>
      ) : (
        <Box display={"flex"} justifyContent={"space-between"}>
          <TitleRegister>Editar Persona</TitleRegister>
          <IconButton onClick={close}>
            <X size={30} />
          </IconButton>
        </Box>
      )}
      <Box sx={{ gap: 2, display: "grid" }}>
        <Box>
          <TextFieldBOValidate
            register={register}
            name="name"
            label={"Nombre de la persona"}
            errors={errors}
            isRequired
            maxLength={50}
            length={name?.length}
          />
        </Box>
        <Box>
          <DatePickerCustom
            control={control}
            dateFormat={FORMAT_DATES?.standard}
            name="birthdate"
            label={"Fecha de nacimiento"}
            dateField
            errors={errors}
            maxDate={dayjs()}
            isLoading={isLoading}
          />
        </Box>

        <MedicalData register={register} errors={errors} watch={watch} />
        <DataCoberturaMedica
          register={register}
          errors={errors}
          watch={watch}
        />

        <AdittionalData register={register} errors={errors} watch={watch} />

        <Box>
          <Typography>Contacto principal</Typography>
          <InputCelNumber name={"cel"} control={control} />
          <Typography>Contacto secundario</Typography>
          <InputCelNumber name={"tel"} control={control} />{" "}
        </Box>
      </Box>

      <Box textAlign={"end"}>
        <ButtonLoading isLoading={isLoading}>
          {edit ? "Guardar Persona" : "Registrar Persona"}
        </ButtonLoading>
      </Box>
    </form>
  );
};
